var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiVectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 804,
    height: 778,
    viewBox: "0 0 804 778",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 776C622.788 776 801.772 602.734 801.772 389C801.772 175.266 622.788 2 402.001 2C181.214 2 2.23047 175.266 2.23047 389C2.23047 602.734 181.214 776 402.001 776Z",
    stroke: "url(#paint0_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 761.044C614.256 761.044 786.323 594.474 786.323 389C786.323 183.525 614.256 16.9551 402.001 16.9551C189.746 16.9551 17.6797 183.525 17.6797 389C17.6797 594.474 189.746 761.044 402.001 761.044Z",
    stroke: "url(#paint1_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402.003 746.086C605.723 746.086 770.871 586.214 770.871 389.001C770.871 191.788 605.723 31.916 402.003 31.916C198.283 31.916 33.1348 191.788 33.1348 389.001C33.1348 586.214 198.283 746.086 402.003 746.086Z",
    stroke: "url(#paint2_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 731.13C597.189 731.13 755.421 577.953 755.421 389.001C755.421 200.048 597.189 46.8711 402.001 46.8711C206.813 46.8711 48.582 200.048 48.582 389.001C48.582 577.953 206.813 731.13 402.001 731.13Z",
    stroke: "url(#paint3_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M402.002 716.174C588.658 716.174 739.972 569.694 739.972 389C739.972 208.307 588.658 61.8262 402.002 61.8262C215.346 61.8262 64.0312 208.307 64.0312 389C64.0312 569.694 215.346 716.174 402.002 716.174Z",
    stroke: "url(#paint4_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M402.002 701.219C580.126 701.219 724.523 561.434 724.523 389C724.523 216.566 580.126 76.7812 402.002 76.7812C223.878 76.7812 79.4805 216.566 79.4805 389C79.4805 561.434 223.878 701.219 402.002 701.219Z",
    stroke: "url(#paint5_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.002 686.258C571.591 686.258 709.07 553.171 709.07 388.999C709.07 224.828 571.591 91.7402 402.002 91.7402C232.413 91.7402 94.9336 224.828 94.9336 388.999C94.9336 553.171 232.413 686.258 402.002 686.258Z",
    stroke: "url(#paint6_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M402 671.305C563.057 671.305 693.62 544.913 693.62 389.001C693.62 233.089 563.057 106.697 402 106.697C240.943 106.697 110.381 233.089 110.381 389.001C110.381 544.913 240.943 671.305 402 671.305Z",
    stroke: "url(#paint7_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M402 656.349C554.525 656.349 678.171 536.653 678.171 389.001C678.171 241.348 554.525 121.652 402 121.652C249.476 121.652 125.83 241.348 125.83 389.001C125.83 536.653 249.476 656.349 402 656.349Z",
    stroke: "url(#paint8_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 641.393C545.993 641.393 662.722 528.393 662.722 389C662.722 249.608 545.993 136.607 402.001 136.607C258.008 136.607 141.279 249.608 141.279 389C141.279 528.393 258.008 641.393 402.001 641.393Z",
    stroke: "url(#paint9_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M402.002 626.433C537.46 626.433 647.271 520.13 647.271 389C647.271 257.869 537.46 151.566 402.002 151.566C266.545 151.566 156.734 257.869 156.734 389C156.734 520.13 266.545 626.433 402.002 626.433Z",
    stroke: "url(#paint10_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 611.477C528.927 611.477 631.82 511.87 631.82 388.999C631.82 266.128 528.927 166.521 402.001 166.521C275.075 166.521 172.182 266.128 172.182 388.999C172.182 511.87 275.075 611.477 402.001 611.477Z",
    stroke: "url(#paint11_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M401.999 596.523C520.393 596.523 616.369 503.612 616.369 389.001C616.369 274.389 520.393 181.478 401.999 181.478C283.606 181.478 187.629 274.389 187.629 389.001C187.629 503.612 283.606 596.523 401.999 596.523Z",
    stroke: "url(#paint12_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 581.567C511.863 581.567 600.923 495.352 600.923 389.001C600.923 282.649 511.863 196.434 402.001 196.434C292.14 196.434 203.08 282.649 203.08 389.001C203.08 495.352 292.14 581.567 402.001 581.567Z",
    stroke: "url(#paint13_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 566.607C503.328 566.607 585.469 487.09 585.469 389C585.469 290.91 503.328 211.393 402.001 211.393C300.675 211.393 218.533 290.91 218.533 389C218.533 487.09 300.675 566.607 402.001 566.607Z",
    stroke: "url(#paint14_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 551.651C494.796 551.651 570.021 478.83 570.021 388.999C570.021 299.169 494.796 226.348 402.001 226.348C309.207 226.348 233.982 299.169 233.982 388.999C233.982 478.83 309.207 551.651 402.001 551.651Z",
    stroke: "url(#paint15_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M402 536.698C486.262 536.698 554.57 470.572 554.57 389.001C554.57 307.431 486.262 241.305 402 241.305C317.738 241.305 249.43 307.431 249.43 389.001C249.43 470.572 317.738 536.698 402 536.698Z",
    stroke: "url(#paint16_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M402 521.742C477.73 521.742 539.121 462.312 539.121 389.001C539.121 315.69 477.73 256.26 402 256.26C326.27 256.26 264.879 315.69 264.879 389.001C264.879 462.312 326.27 521.742 402 521.742Z",
    stroke: "url(#paint17_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M402.002 506.782C469.197 506.782 523.67 454.049 523.67 389C523.67 323.951 469.197 271.219 402.002 271.219C334.807 271.219 280.334 323.951 280.334 389C280.334 454.049 334.807 506.782 402.002 506.782Z",
    stroke: "url(#paint18_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M402 491.826C460.663 491.826 508.219 445.789 508.219 389C508.219 332.211 460.663 286.174 402 286.174C343.337 286.174 295.781 332.211 295.781 389C295.781 445.789 343.337 491.826 402 491.826Z",
    stroke: "url(#paint19_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 476.87C452.132 476.87 492.771 437.529 492.771 388.999C492.771 340.47 452.132 301.129 402.001 301.129C351.87 301.129 311.23 340.47 311.23 388.999C311.23 437.529 351.87 476.87 402.001 476.87Z",
    stroke: "url(#paint20_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M401.999 461.916C443.598 461.916 477.32 429.271 477.32 389.001C477.32 348.731 443.598 316.086 401.999 316.086C360.4 316.086 326.678 348.731 326.678 389.001C326.678 429.271 360.4 461.916 401.999 461.916Z",
    stroke: "url(#paint21_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 446.956C435.065 446.956 461.869 421.008 461.869 389C461.869 356.992 435.065 331.045 402.001 331.045C368.937 331.045 342.133 356.992 342.133 389C342.133 421.008 368.937 446.956 402.001 446.956Z",
    stroke: "url(#paint22_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M402.001 432C426.533 432 446.42 412.748 446.42 389C446.42 365.252 426.533 346 402.001 346C377.469 346 357.582 365.252 357.582 389C357.582 412.748 377.469 432 402.001 432Z",
    stroke: "url(#paint23_linear_496_8542)",
    strokeOpacity: 0.15,
    strokeWidth: 2.61292,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_496_8542",
    x1: 19.5179,
    y1: -477.983,
    x2: 1069.03,
    y2: 186.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_496_8542",
    x1: 34.299,
    y1: -444.48,
    x2: 1043.25,
    y2: 194.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_496_8542",
    x1: 49.0858,
    y1: -410.965,
    x2: 1017.47,
    y2: 202.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_496_8542",
    x1: 63.865,
    y1: -377.461,
    x2: 991.692,
    y2: 210.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_496_8542",
    x1: 78.6462,
    y1: -343.957,
    x2: 965.916,
    y2: 218.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_496_8542",
    x1: 93.4274,
    y1: -310.453,
    x2: 940.139,
    y2: 225.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_496_8542",
    x1: 108.212,
    y1: -276.94,
    x2: 914.354,
    y2: 233.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_496_8542",
    x1: 122.991,
    y1: -243.435,
    x2: 888.576,
    y2: 241.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_496_8542",
    x1: 137.773,
    y1: -209.931,
    x2: 862.799,
    y2: 249.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_496_8542",
    x1: 152.554,
    y1: -176.427,
    x2: 837.022,
    y2: 257.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_496_8542",
    x1: 167.341,
    y1: -142.914,
    x2: 811.24,
    y2: 264.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_496_8542",
    x1: 182.12,
    y1: -109.41,
    x2: 785.461,
    y2: 272.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_496_8542",
    x1: 196.899,
    y1: -75.9047,
    x2: 759.682,
    y2: 280.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_496_8542",
    x1: 211.682,
    y1: -42.4008,
    x2: 733.908,
    y2: 288.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_496_8542",
    x1: 226.467,
    y1: -8.88782,
    x2: 708.123,
    y2: 296.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_496_8542",
    x1: 241.248,
    y1: 24.6159,
    x2: 682.346,
    y2: 304.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_496_8542",
    x1: 256.027,
    y1: 58.1217,
    x2: 656.568,
    y2: 311.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_496_8542",
    x1: 270.808,
    y1: 91.6255,
    x2: 630.791,
    y2: 319.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_496_8542",
    x1: 285.595,
    y1: 125.139,
    x2: 605.009,
    y2: 327.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_496_8542",
    x1: 300.375,
    y1: 158.642,
    x2: 579.23,
    y2: 335.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_496_8542",
    x1: 315.156,
    y1: 192.146,
    x2: 553.453,
    y2: 343.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_496_8542",
    x1: 329.935,
    y1: 225.652,
    x2: 527.675,
    y2: 350.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_496_8542",
    x1: 344.722,
    y1: 259.165,
    x2: 501.892,
    y2: 358.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_496_8542",
    x1: 359.503,
    y1: 292.669,
    x2: 476.115,
    y2: 366.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C6682",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EA5DE",
    stopOpacity: 0.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiVectors);
export default __webpack_public_path__ + "static/media/ai-vectors.2a7d88dc975fab4b6cbcf03e09b937ed.svg";
export { ForwardRef as ReactComponent };